import React, { useEffect, useState } from "react";
import "./ProductPage2.css";
import HeroSection from "./components/heroSection/heroSection";
import MobileHero from "./components/heroSection/mobilehero";
import BusinessLoanSection from "./components/BusinessSection/BusinessSection";
import BusinessLoanBenefits from "./components/WhyConsider/whyConsiderBusinessLoan";
import HowBusinessLoansWork from "./components/howBusinessLoanWorks/loanProcess";
import StepsSection from "./components/LoanSteps/LoanSteps";
import BusinessLoanCards from "./components/shoShouldApplySection/whoShouldApply";
import CTASection from "./components/CTASection/ctaSection";
import FooterSection from "./components/footer/footer";
import SEO from "../../SEO/SEO";
import ROUTES from "../../constants/RouteData";

export default function ProductPageV2() {
  const [isMobile, setIsMobile] = useState(false);

  // Set mobile flag based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640); // sm breakpoint in Tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <SEO
        title="Personal Loan – Fast & Easy | DigitMoney"
        description="Apply for a personal loan online with DigitMoney and get instant approval up to ₹5,00,000. Enjoy minimal documentation, flexible repayment options, low interest rates, and 100% digital processing. Ideal for medical, wedding, travel, or emergency needs."
        keywords="Personal Loan, Instant Loan, Online Personal Loan, Emergency Loan, Loan Without Collateral, Quick Loan Approval, Medical Loan, Wedding Loan, Travel Loan, DigitMoney Loan App"
        image="https://campaigns.digitmoney.in/assets/img/DMIcon.png"
        url={`https://campaigns.digitmoney.in/${ROUTES.home}`}
      />

      <div className="w-full flex flex-col items-center bg-[#FBF8F3]">
        {isMobile ? <MobileHero /> : <HeroSection />}
        <BusinessLoanSection />
        <BusinessLoanBenefits />
        <HowBusinessLoansWork />
        <StepsSection />

        <CTASection />
        <FooterSection />
      </div>
    </>
  );
}
